import { Link, Typography } from "@mui/material";
import * as React from "react";
import { Clip } from "../../../Core/Api/Types/clip";
import { ModalContext } from "../../Modals";
import ModalShareClip, { ModalShareClipElementProps } from "../../Modals/ModalShareClip/modal-share-clip";
import { useTranslation } from "react-i18next";

export interface TableCellShareClipsProps {
  shareId: number;
  clips: Clip[];
  clipsCallback: (clips: number[], linkedAssetId: number) => void;
}

const TableCellShareClips: React.FC<TableCellShareClipsProps> = ({ clips, shareId, clipsCallback }) => {
  const { t } = useTranslation();
  const modalContext = React.useContext(ModalContext);
  const { openModal } = { ...modalContext };

  const handleShowClips = (e) => {
    e.stopPropagation();
    if (!openModal) return;
    openModal<ModalShareClipElementProps>(ModalShareClip, {
      shareId,
      clips,
      clipsCallback,
    });
  };

  return (
    <>
      {clips.length > 0 && (
        <Link
          underline="hover"
          color={!clips.every((x) => x.importedOnAssetId) ? "primary.text" : "text.secondary"}
          component="button"
          onClick={(e) => handleShowClips(e)}
        >
          {t("common:clipsWithCount", { count: clips.length })}
        </Link>
      )}
    </>
  );
};

export default TableCellShareClips;
